import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm"; // Importar el modal de confirmación
import ModalAgregarArticuloComanda from './ModalAgregarArticuloComanda'; // Importar el modal de agregar artículo

const ArticulosComanda = ({ comandaId }) => {
    const [articulos, setArticulos] = useState([]);
    const [busqueda, setBusqueda] = useState(""); // Barra de búsqueda
    const [editandoArticulo, setEditandoArticulo] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [articuloSeleccionado, setArticuloSeleccionado] = useState(null); // Para almacenar el artículo seleccionado para eliminar
    const [mostrarFormulario, setMostrarFormulario] = useState(false); // Controla la visibilidad del formulario para agregar artículos

    // Obtener artículos de comanda
    const obtenerArticulos = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "articulos_comanda"
            });
            
            if (response.data && response.data.data && Array.isArray(response.data.data[0])) {
                setArticulos(response.data.data[0].filter((articulo) => articulo.comanda_id === comandaId));
            } else {
                console.error("La estructura de la respuesta no es la esperada.");
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        obtenerArticulos();  // Llamamos la función para obtener los artículos de la comanda
    }, [comandaId]);

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar artículos por búsqueda
    const articulosFiltrados = articulos.filter((articulo) =>
        articulo.articulo_menu_id.toString().includes(busqueda) || // Filtrar por ID del artículo en el menú
        articulo.cantidad.toString().includes(busqueda) || // Filtrar por cantidad
        articulo.precio.toString().includes(busqueda) // Filtrar por precio
    );

    // Función para manejar la edición de un artículo
    const editarArticulo = (articulo) => {
        setEditandoArticulo(articulo);
    };

    // Función para guardar los cambios del artículo editado
    const guardarArticuloEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "articulos_comanda",
                id: editandoArticulo.id,
                comanda_id: editandoArticulo.comanda_id,
                articulo_menu_id: editandoArticulo.articulo_menu_id,
                cantidad: editandoArticulo.cantidad,
                precio: editandoArticulo.precio
            });
            setEditandoArticulo(null);
            obtenerArticulos(); // Actualizar los artículos después de guardar
        } catch (error) {
            console.log(error);
        }
    };

    // Función para eliminar un artículo
    const confirmarEliminarArticulo = (articulo) => {
        setArticuloSeleccionado(articulo);
        setShowConfirmModal(true); // Mostrar el modal de confirmación
    };

    const eliminarArticulo = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "articulos_comanda",
                id: articuloSeleccionado.id
            });
            setShowConfirmModal(false); // Cerrar el modal de confirmación
            obtenerArticulos(); // Actualizar los artículos después de eliminar
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Artículos de la Comanda</h3>

                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar por ID de artículo, cantidad o precio..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />

                {/* Botón para mostrar el formulario de agregar artículo */}
                <button
                    onClick={() => setMostrarFormulario(true)}
                    className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-6 hover:bg-blue-400"
                >
                    Agregar Nuevo Artículo
                </button>

                <ul>
                    {articulosFiltrados.map((articulo) => (
                        <li key={articulo.id} className="border p-2 mb-2 mt-4">
                            {editandoArticulo && editandoArticulo.id === articulo.id ? (
                                <div className="flex flex-col">
                                    <h3 className=" font-semibold mt-2">ID del Artículo en el Menú:</h3>
                                    <input
                                        type="number"
                                        value={editandoArticulo.articulo_menu_id}
                                        onChange={(e) =>
                                            setEditandoArticulo({ ...editandoArticulo, articulo_menu_id: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={10}
                                    />
                                    <h3 className=" font-semibold mt-2">Cantidad:</h3>
                                    <input
                                        type="number"
                                        value={editandoArticulo.cantidad}
                                        onChange={(e) =>
                                            setEditandoArticulo({ ...editandoArticulo, cantidad: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={10}
                                    />
                                    <h3 className=" font-semibold mt-2">Precio:</h3>
                                    <input
                                        type="number"
                                        value={editandoArticulo.precio}
                                        onChange={(e) =>
                                            setEditandoArticulo({ ...editandoArticulo, precio: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={10}
                                    />
                                    <div className="flex mt-4 mb-2">
                                        <button
                                            onClick={guardarArticuloEditado}
                                            className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoArticulo(null)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <span><strong>ID del Artículo en el Menú:</strong> {articulo.articulo_menu_id}</span><br />
                                    <span><strong>Cantidad:</strong> {articulo.cantidad}</span><br />
                                    <span><strong>Precio:</strong> ${articulo.precio}</span><br />
                                    <button
                                        onClick={() => editarArticulo(articulo)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarArticulo(articulo)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Modal de confirmación */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este artículo?"
                onConfirm={eliminarArticulo}
                onCancel={() => setShowConfirmModal(false)}
            />

            <ModalAgregarArticuloComanda
                show={mostrarFormulario}
                onClose={() => setMostrarFormulario(false)}
                comandaId={comandaId}
                onArticuloAgregado={obtenerArticulos} // Actualiza los artículos después de agregar uno nuevo
            />
        </div>
    );
};

export default ArticulosComanda;
